import { CheckCircleIcon } from '@heroicons/react/outline';
import { FC } from 'react';

export const SuccessModalIcon: FC = () => {
  return (
    <div className='flex size-12 items-center justify-center rounded-full bg-green-100 text-green-600'>
      <CheckCircleIcon className='size-6' aria-hidden='true' />
    </div>
  );
};
